import React from "react";
import Title from "./Title";
import Content from "./Content";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";

const AddOns = () => {
    return (
        <PageContentWrapper>
            <Title />
            <Content />
        </PageContentWrapper>
    );
};

export default AddOns;
